const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

const canFinishOperative = (immSignaturePattern, immPrinter) => {
    let result;

    const isLoadingChallenge = immSignaturePattern.get('isFetchingConfig');
    const hasChallenge =
        !!immSignaturePattern.get('requiredDigits') ||
        !!immSignaturePattern.get('requiredSMS');
    const challengeCompleted =
        !hasChallenge ||
        !!immSignaturePattern.get('inputValueSMS') ||
        !!immSignaturePattern.get('consumerFinishInputDigits');

    if (isPrintOfficeMode()) {
        const isShowingPreview = immPrinter.get('isShowingPreview');
        const documentsPrintedAndSigned =
            immPrinter.get('documentsPrintedAndSigned') === 'YES';

        result =
            !isLoadingChallenge &&
            challengeCompleted &&
            isShowingPreview &&
            documentsPrintedAndSigned;
    } else {
        result = !isLoadingChallenge && challengeCompleted;
    }

    return result;
};

module.exports = {
    canFinishOperative,
};
